import { render, staticRenderFns } from "./property-modal-config-field.vue?vue&type=template&id=2ab9d350&"
import script from "./property-modal-config-field.vue?vue&type=script&lang=js&"
export * from "./property-modal-config-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports